import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLNonNull,
  GraphQLID,
  GraphQLInt,
  GraphQLList,
  GraphQLBoolean
} from 'graphql';

import Node from './node.gql';
import CourseType from './course.gql';
import CompletionStatusEnumType from './enums/completionStatus.gql';
import SuccessStatusEnumType from './enums/successStatus.gql';

const curriculumPerformanceType = new GraphQLObjectType({
  name: 'CurriculumPerformance',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID)
    },
    pid: {
      type: GraphQLString
    },
    percentCompleted: {
      type: GraphQLInt
    },
    lastVisitedCourse: {
      type: new GraphQLList(CourseType),
      resolve: item => item.lastVisitedCourse.slice()
    },
    completionStatus: {
      type: CompletionStatusEnumType
    },
    successStatus: {
      type: SuccessStatusEnumType
    },
    lastUpdated: {
      type: GraphQLString
    },
    isRequired: {
      type: GraphQLBoolean
    }
  }),
  interfaces: [Node.nodeInterface]
});

window[curriculumPerformanceType.name + 'GQLType'] = curriculumPerformanceType;

export default curriculumPerformanceType;
